/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AzureDevOpsPipelineListProjectsResponse {
    getFixupPrototypeFunction() { return AzureDevOpsPipelineListProjectsResponse.fixupPrototype; }

    static newInstance(model: Partial<AzureDevOpsPipelineListProjectsResponse>): AzureDevOpsPipelineListProjectsResponse {
        let obj = Object.assign(new AzureDevOpsPipelineListProjectsResponse(), model);
        AzureDevOpsPipelineListProjectsResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AzureDevOpsPipelineListProjectsResponse>): AzureDevOpsPipelineListProjectsResponse {
        if (!model) return null;
        return AzureDevOpsPipelineListProjectsResponse.newInstance(<AzureDevOpsPipelineListProjectsResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AzureDevOpsPipelineListProjectsResponse) {
        if (!obj) return;

        models.AzureDevOpsPipelineListProjectsResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AzureDevOpsPipelineListProjectsResponse): boolean {
        Object.setPrototypeOf(obj, AzureDevOpsPipelineListProjectsResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.projects) {
            for (let val of this.projects) {
                models.AzureDevOpsProject.fixupPrototype(val);
            }
        }
    }

    /**
     * List of project name
     */
    projects: Array<models.AzureDevOpsProject>;

}
